import React from 'react';
import './Footer.css';

const Footer = () => {
    return (

        <div className='bg-secondary text-center mt-5 footer'>
            <h6>©2022 || All rights reserved</h6>
            <a className='text-white mx-4 ' href="">Terms and Conditions</a>
            <a className='text-white mx-4' href="">Our Policy</a>
        </div >

    );
};

export default Footer;